export const invertedMessages = {
  'Auto Approved': 'CERTS_AUTO_APPROVED',
};
